import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ROUTER_CONFIG } from '@core/configs';
import { AuthService } from '@core/services/apis';

export const liveRoleGuard: CanActivateFn = (): boolean => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (!authService.loggedIn()) {
    router.navigate([ROUTER_CONFIG.auth.login]);
    return false;
  }
  return true;
};
